import { createContext, useContext } from 'react';

interface MessageContextProps {
  setErrorMessage: (errorMessage: string) => void;
  setSuccessMessage: (successMessage: string) => void;
  setInfoMessage: (infoMessage: string) => void;
}

export const MessageContext = createContext<MessageContextProps>({
  setErrorMessage: () => {
    console.error('unimplemented context messageContext');
  },
  setSuccessMessage: () => {
    console.error('unimplemented context messageContext');
  },
  setInfoMessage: () => {
    console.error('unimplemeneted context messageContext');
  },
});

export const useMessage = () => useContext(MessageContext);
